import { Injectable } from '@angular/core';
import { Config } from '../config/config';
import { RestDataService } from './rest-data.service';

@Injectable()
export class LocalstorageService {
  
  constructor(private restService:RestDataService,
    private config:Config ) 
    { }


getMetaData(){
 let getMetaData=JSON.parse(localStorage.getItem('metaData'));
 return getMetaData;
}

setSuggestionData(){
  
  this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/suggestions')
  .subscribe(
    data => {
     localStorage.setItem('suggestionData',JSON.stringify(data));
    },(err)=>console.log(err))
  
}

getSuggestionData(){
  let suggestionData=JSON.parse(localStorage.getItem('suggestionData'));
  return suggestionData;
}

}
